import { Condition } from '@medplum/fhirtypes';
import { HpoItem } from '@/types/hpo.types';
import { PREFIXES, SYSTEMS } from '@/consts/systems.consts';
import { HPO_ANNOTATION_API_URL } from '@/consts/api.consts';

export function getOmimIdFromCondition(
  condition: Condition
): string | undefined {
  const omimCoding = condition.code?.coding?.find(
    (c) => c.system === SYSTEMS.OMIM
  );
  if (!omimCoding) {
    return undefined;
  }
  return `${PREFIXES.OMIM}${omimCoding.code}`;
}

export async function fetchDiseaseHPO(omimCode: string): Promise<HpoItem[]> {
  interface RawHpoTerm {
    id: string;
    name: string;
    category: string;
  }

  interface RawHpoResponse {
    categories: Record<string, RawHpoTerm[]>;
  }

  try {
    const response = await fetch(
      `${HPO_ANNOTATION_API_URL}${encodeURIComponent(omimCode)}`
    );
    const data: RawHpoResponse = await response.json();

    if (!data.categories) {
      return [];
    }

    return Object.entries(data.categories).flatMap(([_category, terms]) =>
      terms.map((term) => ({
        id: term.id,
        name: term.name,
        value: term.category,
      }))
    );
  } catch (e) {
    console.error('Error fetching HPO terms', e);
    return [];
  }
}
